// Swiper JS Plugin
// [ https://uiinitiative.com/catalog/slicer-slider ]
import EffectSlicer from '/src/build/lib/swiperjs/effect-slicer.esm.js';
window.EffectSlicer = EffectSlicer;
import '/src/build/lib/swiperjs/effect-slicer.css';

// [ https://uiinitiative.com/catalog/shaders-slider ]
import SwiperGL from '/src/vendor/swiperjs/swiper-gl.esm.js';
window.SwiperGL = SwiperGL;
import '/src/vendor/swiperjs/swiper-gl.css';

// [ https://uiinitiative.com/catalog/shutters-slider ]
import EffectShutters from '/src/build/lib/swiperjs/effect-shutters.esm.js';
window.EffectShutters = EffectShutters;
import '/src/build/lib/swiperjs/effect-shutters.css';

// [ https://uiinitiative.com/catalog/carousel-slider ]
import EffectCarousel from '/src/build/lib/swiperjs/effect-carousel.esm.js';
window.EffectCarousel = EffectCarousel;
import '/src/build/lib/swiperjs/effect-carousel.css';

// [ https://uiinitiative.com/catalog/material-you-slider ]
import EffectMaterial from '/src/build/lib/swiperjs/effect-material.esm.js';
window.EffectMaterial = EffectMaterial;
import '/src/build/lib/swiperjs/effect-material.css';

import { average } from 'color.js';
if (typeof window.colorjs == 'undefined') { window.colorjs = {}; }
window.colorjs.average = average;

// [ https://uiinitiative.com/catalog/fashion-slider ] createFashionSlider(el)
import 'script-loader!/src/build/lib/swiperjs/fashion-slider.js';
import '/src/build/lib/swiperjs/fashion-slider.css';